import React, { useEffect } from 'react';
import { useLocation } from 'wouter';
import { useActiveContext } from '@/hooks/useActiveContext';
import { FullPageLoading } from '@/components/FullPageLoading';

interface ContextRedirectProps {
  targetPath?: string;
}

export function ContextRedirect({ targetPath = 'inbox' }: ContextRedirectProps) {
  const [, navigate] = useLocation();
  const { activeContext, isLoading } = useActiveContext();
  
  useEffect(() => {
    if (!isLoading) {
      if (activeContext) {
        // Redirect to the active context's target page
        navigate(`/context/${activeContext._id}/${targetPath}`);
      } else {
        // No active context available, redirect to context management page
        navigate('/contexts');
      }
    }
  }, [activeContext, isLoading, navigate, targetPath]);
  
  // Show loading while determining where to redirect
  return <FullPageLoading />;
}